export default __webpack_public_path__ + "static/media/seta.8641cfa3.svg";